import { createTheme } from '@mui/material/styles'

const themes = {
  LIGHT: {
    white: '#ffffff',
    black: '#000000',
    semiTranpBlack: '#0000008C',
    yellow: '#ffc107',
    linkColor: '#1976d2',
    whisper: '#f5f7fb',
    gray: '#d3d3d3',
    lightGray: '#DDD',
    lightGrey: '#ccc',
    lightYellow: '#F2DF97'
  }
}

export const makeTheme = mode => {
  const currentTheme = themes[mode]

  return createTheme({
    typography: {
      fontFamily: `'Avenir Next LT Pro', Arial, Helvetica, sans-serif`
    },
    components: {
      MuiFormControl: {
        styleOverrides: {
          marginNormal: {
            margin: 0
          }
        }
      }
    },
    colors: {
      white: currentTheme.white,
      black: currentTheme.black,
      semiTranpBlack: currentTheme.semiTranpBlack,
      yellow: currentTheme.yellow,
      linkColor: currentTheme.linkColor,
      whisper: currentTheme.whisper,
      gray: currentTheme.gray,
      lightGray: currentTheme.lightGray,
      lightGrey: currentTheme.lightGrey,
      lightYellow: currentTheme.lightYellow
    }
  })
}

export const makeIconSize = size => {
  switch (size) {
    case 'xsmall':
      return '1.4rem'
    case 'small':
      return '1.6rem'
    case 'medium':
      return '1.8rem'
    case 'large':
      return '2.0rem'
    default:
      return '1.8rem'
  }
}
